// extracted by mini-css-extract-plugin
module.exports = {"recentlyViewed":"RecentlyViewed-module__recentlyViewed___1EJU5","carousel":"RecentlyViewed-module__carousel___1nFxt"};